const DISMISSED = 'ft.sessionReminder.dismissed.';
const NOTIFIED = 'ft.sessionReminder.notified.';
const MAX_AGE = 2 * 86400000;
const memory = new Map<string, number>();

function read(key: string): number {
    try { return Number(localStorage.getItem(key)) || memory.get(key) || 0; }
    catch { return memory.get(key) || 0; }
}

function write(key: string): void {
    const at = Date.now();
    memory.set(key, at);
    try { localStorage.setItem(key, String(at)); } catch { /* Tab-local fallback. */ }
}

export function pruneReminderStorage(): void {
    try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && (key.startsWith(DISMISSED) || key.startsWith(NOTIFIED))) {
                const at = Number(localStorage.getItem(key));
                if (!at || Date.now() - at > MAX_AGE) localStorage.removeItem(key);
            }
        }
    } catch { /* Storage may be disabled. */ }
}

export const isDismissed = (id: string): boolean => read(DISMISSED + id) > Date.now() - MAX_AGE;
export const dismiss = (id: string): void => write(DISMISSED + id);
export const wasNotified = (id: string): boolean => read(NOTIFIED + id) > Date.now() - MAX_AGE;
export const markNotified = (id: string): void => write(NOTIFIED + id);
export function dismissedSession(event: StorageEvent): string | null {
    return event.key?.startsWith(DISMISSED) && Number(event.newValue) > Date.now() - MAX_AGE
        ? event.key.slice(DISMISSED.length) : null;
}
